import { styled as muiStyled, css } from '@mui/material/styles';
import { SxProps } from '@mui/system';

interface Props {
  /**
   * MUI style overrides
   */
  sx?: SxProps;
  alignContent?:
    | 'center'
    | 'flex-end'
    | 'flex-start'
    | 'space-around'
    | 'space-between';
  alignItems?: 'center' | 'flex-end' | 'flex-start' | 'stretch';
  direction?: 'column' | 'row' | 'row-reverse' | 'column-reverse';

  justify?:
    | 'center'
    | 'flex-end'
    | 'flex-start'
    | 'space-around'
    | 'space-between';
  inline?: boolean;
  shouldWrap?: boolean;
}

export const Arranger = muiStyled('div')<Props>(
  (props) => css`
    display: flex;

    display: ${props.inline && 'inline-flex'};
    flex-wrap: ${props.shouldWrap && 'wrap'};

    align-content: ${props.alignContent};
    align-items: ${props.alignItems};
    flex-direction: ${props.direction ?? 'row'};
    justify-content: ${props.justify};
  `
);

export default Arranger;
